import teamComponentMapCp from './cp'
import teamComponentMapCrm from './crm'
import teamComponentMapSourcing from './sourcing'

export const teamComponentMaps = {
  crm: teamComponentMapCrm,
  cp: teamComponentMapCp,
  sourcing: teamComponentMapSourcing,
}
